import { createFileRoute } from '@tanstack/react-router';
import { StaticPage } from '../components/static/StaticPage';
import { getStaticPage } from '../lib/static-content';
import { staticHead } from '../lib/seo';

export const Route = createFileRoute('/sitemap')({
  head: () => {
    const p = getStaticPage('sitemap');
    return staticHead({ pathname: '/sitemap', title: p.title, description: p.metaDescription });
  },
  component: () => <StaticPage slug="sitemap" />,
});
